import { IframeUtility } from '@inter-ikea-kompis/utilities';
/**
 * This class handles communication with the IRW application through post message.
 */
export default class IrwPlatformCommunication {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.applicationName Application name.
     */
    constructor(options) {
        this.applicationName = options.applicationName;
    }
    /**
     * Sets the iframe container height.
     *
     * @param height Height to set.
     */
    setIframeHeight(height) {
        if (IframeUtility.isInsideIframe()) {
            window.parent.postMessage({
                header: {
                    name: 'setContainerSize'
                },
                body: {
                    height: height,
                    containerName: this.getContainerName()
                }
            }, '*');
        }
    }
    /**
     * Sets the cart count.
     *
     * @param cartCount Cart count to set.
     */
    setCartCount(cartCount) {
        if (IframeUtility.isInsideIframe()) {
            window.parent.postMessage({
                header: {
                    name: 'shoppingcartCount'
                },
                body: {
                    count: cartCount,
                    containerName: this.getContainerName()
                }
            }, '*');
        }
    }
    /**
     * Returns the iframe container name.
     *
     * @returns Iframe container name.
     */
    getContainerName() {
        return '#' + this.applicationName + '-application';
    }
}
//# sourceMappingURL=IrwPlatformCommunication.js.map